var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"m-headline"},[(_vm.small)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"keep-new-line"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }